export const GET_CONTRACTS = "GET_CONTRACTS";
export const GET_CONTRACT = "GET_CONTRACT";
export const GET_PDC = "GET_PDC";
export const SET_RENEWAL_FILTERS = "SET_RENEWAL_FILTERS";
export const SET_MOVEOUT_FILTERS = "SET_MOVEOUT_FILTERS";
